export default "__VITE_ASSET__CbqkvJDZ__"